import React from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Typography, LinearProgress, Alert, Button,
} from '@mui/material';

/**
 * props:
 *   open   : boolean
 *   pct    : number   // 0 – 100
 *   onClose: () => void
 */
export default function UploadProgressDialog({ open, pct = 0, onClose }) {
    const done = pct >= 100;

    return (
        <Dialog open={open} onClose={done ? onClose : undefined} fullWidth maxWidth="xs">
            <DialogTitle>Upload</DialogTitle>

            <DialogContent>
                {!done ? (
                    <>
                        <Typography variant="body2" sx={{ mb: 2 }}>
                            Upload&nbsp;{pct}%
                        </Typography>
                        <LinearProgress variant="determinate" value={pct} />
                    </>
                ) : (
                    <Alert severity="success">
                        Upload completed. Processing of the data will take some time. For more information, check the backend logs.
                        You can now return to &nbsp;Release&nbsp;Management or close the page.
                    </Alert>
                )}
            </DialogContent>

            <DialogActions>
                {done && (
                    <Button variant="contained" onClick={onClose}>
                        Back
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
}
